import {Component, Input, OnInit} from '@angular/core';
import { PdfViewerModule, PdfViewerComponent } from 'ng2-pdf-viewer';

@Component({
  selector: 'app-view-doc',
  templateUrl: './view-doc.component.html',
  styleUrls: ['./view-doc.component.css'], 
  providers: [PdfViewerComponent],
})
export class ViewDocComponent implements OnInit {
  @Input() resource;
  constructor() { }

  ngOnInit(): void {
    console.log(this.resource);
  }

}
